import styled from 'styled-components';

export const ConfirmedTagGroup = styled.div`
  & > *:last-child {
    padding: 0;
    margin-left: 15px;
  }
`;
